import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild, Output, EventEmitter, Input, SimpleChanges, NgZone } from '@angular/core';
import { ItemSpot } from 'src/app/models/item-spot.model';
import { IonInfiniteScroll } from '@ionic/angular';
import { RequestCreationService } from 'src/app/core/services/request-creation/request-creation.service';
import { UtilsService } from 'src/app/core/services/utils/utils.service';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { Skeleton } from 'src/app/models/skeleton.model';

@Component({
  selector: 'cc-item-spot-list',
  templateUrl: './item-spot-list.component.html',
  styleUrls: ['./item-spot-list.component.scss'],
})
export class ItemSpotListComponent implements OnInit {

  public itemsSpots: ItemSpot[] = [];
  private nextPage: number = 1;
  public httpError: string = null;
  public total: number;
  private searchParam: string = '';
  public showLoader: boolean = false;
  public selectedItemId: number = null;

  public skeleton: Skeleton = {
    secondLine: true, show: true
  }
  private unitParams;

  @ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll: IonInfiniteScroll;

  @Input() enclosureId: number;
  @Input() activeStep: number;
  @Input() company: string = '';
  @Output() selected = new EventEmitter<any>();

  constructor(
    private requestCreationService: RequestCreationService,
    private utils: UtilsService,
    private keyboard: Keyboard,
    private ngZone: NgZone,
    private translate : TranslateService
  ) { }

  async ngOnInit() {
    this.unitParams = await this.utils.getFromStorage('unitParams');
    if (this.enclosureId) {
      this.skeleton.show = true;
      this.getItemSpot();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.enclosureId && !changes.enclosureId.isFirstChange()) {
      this.itemsSpots = [];
      this.skeleton.show = true;
      this.nextPage = 1;
      this.getItemSpot();
    }
  }

  async getItemSpot(ev?, search?) {
    if (search) {
      this.showLoader = true;
    }
    this.requestCreationService.getItemsSpots(this.company, this.enclosureId, this.nextPage, this.unitParams, search)
      .subscribe(async ({ data, current_page, total, error, operation }: { data: ItemSpot[], current_page: number, total: number, error, operation: string }) => {
        this.showLoader = false;
        this.skeleton.show = false;
        if (error) {
          this.httpError = operation;
          this.utils.showMessage(operation);
        } else {
          this.httpError = null;
          this.ngZone.run(() => {
            this.itemsSpots.push(...data)
            setTimeout(() => {
              this.utils.updateSlide.emit();
            }, 100);
          });

          this.total = total;
        }

        if (ev) {
          ev.target.complete();
          if (this.itemsSpots.length == total)
            ev.target.disabled = true;
        }
      });
  }

  search({ detail: { value } }) {
    this.nextPage = 1;
    if (value.length > 1) {
      this.itemsSpots = [];
      this.getItemSpot(null, value);
      this.searchParam = value;
    } else if (value.length === 0) {
      this.cleanSearch();
    }
  }

  cleanSearch() {
    this.keyboard.hide();
    this.itemsSpots = [];
    this.searchParam = ''
    this.skeleton.show = true;
    this.getItemSpot();
  }

  loadMore(ev) {
    this.nextPage++;
    if (this.activeStep === 1) {
      if (this.searchParam) {
        this.getItemSpot(ev, this.searchParam);
      }
      else
        this.getItemSpot(ev);
    }
  }

  selectItemSpot(item: ItemSpot) {
    if (item.bloqueado) {
      return;
    }
    this.selectedItemId = item.id;
    this.selected.emit(this.itemsSpots.find((el: ItemSpot) => item.id === el.id));
  }

  preventDefault(e: Event, isEnabled: boolean) {
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = isEnabled;
  }

  disableScroll(isEnabled: boolean) {
    window.addEventListener("wheel", (e: WheelEvent) => {
      this.preventDefault(e, isEnabled)
    })

    window.addEventListener("touchmove", (e: TouchEvent) => {
      this.preventDefault(e, isEnabled)
    })
  }


}
